module.exports = __webpack_public_path__ + "assets/badge.767f1c9e4d58a9dd52c8f118fe9c52e6.svg";